import React from 'react'
import PasswordChangeModal from '../modals/PasswordChangeModal'
import { usePasswordChangeCheck } from '../../hooks/usePasswordChangeCheck'

interface PasswordChangeWrapperProps {
  children: React.ReactNode
}

export const PasswordChangeWrapper: React.FC<PasswordChangeWrapperProps> = ({ children }) => {
  const {
    showPasswordModal,
    handlePasswordChangeSuccess,
    handlePasswordChangeCancel,
    isForced
  } = usePasswordChangeCheck()

  return (
    <>
      {children}
      <PasswordChangeModal
        isOpen={showPasswordModal}
        onClose={handlePasswordChangeCancel}
        isForced={isForced}
        onSuccess={handlePasswordChangeSuccess}
      />
    </>
  )
}
